import { createTheme } from "@dash/default-theme";
import { Theme, ThemeProvider } from "@emotion/react";
import { MegaraxWebappContainer } from "@megarax/features";
import { MdSupport } from "react-icons/md";
import { Navigate, Outlet, Route } from "react-router-dom-v5-compat";

import { getMegaraxPath } from "@megaron/megarax-uri";

import { SupportCreateTicketPage } from "./support/pages/SupportCreateTicketPage";
import { SupportSettingsPage } from "./support/pages/SupportSettingsPage";
import { SupportTicketPage } from "./support/pages/SupportTicketPage";
import { SupportTicketsPage } from "./support/pages/SupportTicketsPage";

const supportTheme: Theme = createTheme("273");

export const useSupportRouter = () => {
  return (
    <Route
      path="/support"
      element={
        <ThemeProvider theme={supportTheme}>
          <SupportWebappContainer />
        </ThemeProvider>
      }
    >
      <Route path="" element={<Navigate to={getMegaraxPath.uri("megarax://support/tickets")} replace />} />
      <Route path="tickets" element={<SupportTicketsPage />} />
      <Route path="tickets/new" element={<SupportCreateTicketPage />} />
      <Route path="tickets/id/:id" element={<SupportTicketPage />} />
      <Route path="settings" element={<SupportSettingsPage />} />
    </Route>
  );
};

const SupportWebappContainer: React.FC = () => {
  return (
    <MegaraxWebappContainer logo={<MdSupport width="1em" height="1em" />} title="Support" subtitle="Megarax.net">
      <Outlet />
    </MegaraxWebappContainer>
  );
};
